import { memo } from 'react';
import SectionTitle from '../../../../../components/sharedcomponents/SectionTitle';
import BarRow from '../../../../../components/sharedcomponents/BarRow';
import AnimatedCounter from '../../../../../components/sharedcomponents/Animations/AnimatedCounter';

interface PageEntry {
  pageTitle: string;
  pagePath: string;
  pageViews: string;
}

interface PagesTabProps {
  data: PageEntry[];
}

const PagesTab = memo(({ data }: PagesTabProps) => {
  const pages = data.slice(0, 10);
  const maxViews = pages.length ? parseInt(pages[0]?.pageViews) || 1 : 1;

  return (
    <div>
      <SectionTitle>Pages Les Plus Visitées</SectionTitle>
      <div className="bg-white rounded-2xl border border-blue-100 shadow-sm p-5">
        {pages.map((p, i) => (
          <BarRow
            key={i}
            label={p.pageTitle || 'Sans titre'}
            sublabel={p.pagePath}
            percentage={(parseInt(p?.pageViews || '0') / maxViews) * 100}
            value={
              <AnimatedCounter
                end={parseInt(p?.pageViews || '0')}
                suffix=" vues"
                duration={1100 + i * 120}
              />
            }
          />
        ))}
      </div>
    </div>
  );
});

PagesTab.displayName = 'PagesTab';

export default PagesTab;